import React from 'react';

interface State {}

const UsersGradePage = () => {
  return <>진행x</>;
};

export default UsersGradePage;
